































import { Component , Vue } from 'vue-property-decorator';
import { DateUtils } from '@/util/dateUtils';
import { MedTransGoConstants } from '@/util/constants';
import { Document } from '@/types/entity';
@Component({
    props: {
        documents: Object,
        certificates: Object,
    },
})
export default class DocumentExpirationAlertModal extends Vue {
    private show = true;
    private expiredDocuments: Document[] = [];
    private expiredCertificates: any[] = [];
    private isDocumentsExpired = false;
    private isCertificatesExpired = false;
    public mounted() {
        this.showExpiredDocuments();
        if (this.$props.documents && this.$props.documents.length > 0) {
            this.isDocumentsExpired = true;
            this.showExpiredDocuments();
        }
        if (this.$props.certificates && this.$props.certificates.length > 0) {
            this.showExpiredCertificates();
            this.isCertificatesExpired = true;
        }
    }

    private showExpiredDocuments() {
        const documents: Document[] = this.$props.documents;
        for (const document of documents) {
            if (document.expirationDate && document.expirationDate <= DateUtils.getCurrentTimeInMillis()) {
                this.expiredDocuments.push(document);
                document.expirationDate = document.expirationDate ?
                    DateUtils.formatDate(document.expirationDate, 'MM/DD/YYYY') : '-' as any;
            }
        }
    }

    private showExpiredCertificates() {
        const certificates: any[] =  this.$props.certificates;
        for (const certificate of certificates) {
            certificate.certificates.forEach((element: any) => {
                if (element.expirationTime && element.expirationTime <= DateUtils.getCurrentTimeInMillis()) {
                    this.expiredCertificates.push ({
                        languageName: certificate.languageName,
                        expirationDate: element.expirationTime ?
                        DateUtils.formatDate(element.expirationTime, 'MM/DD/YYYY') : '-' as any,
                    });
                }
            });

        }
    }

    private close() {
        this.$emit('close');
    }

    private goToDocument() {
        this.$router.push ({ name: MedTransGoConstants.VIEW_SETTING_NAME });
        this.$emit('close');
    }

}
